import base from '@nextories/vue-tasks/src/i18n/langs/fr/base';

export default {
  ...base,
  title: 'Coordinator',
  documentTitle: {
    ...base.documentTitle,
    sav: '@:base.title - SAV',
    furnitureStorage: '@:base.title - Garde-Meubles',
  },
};
